const fetchTamedDatas = async (topicId: string) => {
    if (!topicId || topicId === 'undefined') {
        console.warn('Cannot fetch tamed data: invalid topicId', topicId);
        return [];
    }
    
    const response = await fetch(`/api/tamed-data/topic`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ topicId }),
    });
    const responseJson = await response.json();
    return responseJson;
}

export const tamedDatasService = { fetchTamedDatas }
